import { EditorContent } from '@tiptap/react';
import type { FC } from 'react';
import { DisplayBox } from './style';
import { useRichTextEditor } from './useRichTextEditor';

type Props = {
  markdown: string;
};

export const RichTextDisplay: FC<Props> = ({ markdown }) => {
  const { editor } = useRichTextEditor({ value: markdown, isEditable: false });
  return (
    <DisplayBox>
      <EditorContent editor={editor} />
    </DisplayBox>
  );
};
